import { createModerator } from "../createMockData/createModerator";

// avatars
import HeatherAvatar from "./heather.jpg";
import MariaAvatar from "./maria.jpg";
import MitchAvatar from "./mitch.png";

export const moderators = [
    createModerator({
        id: "moderator-1",
        displayName: "Maria Misa",
        username: "maria-misa",
        avatarUrl: MariaAvatar,
        isManager: true
    }),
    createModerator({
        id: "moderator-2",
        displayName: "Heather Park",
        username: "heather-park",
        avatarUrl: HeatherAvatar
    }),
    createModerator({
        id: "moderator-3",
        displayName: "Mitch Gohman",
        username: "mitch-gohman",
        avatarUrl: MitchAvatar
    })
];

export const defaultModerator = moderators[0];
